import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Switch } from '../ui/switch';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-admin`;

// Admin waives the Tier 1 ($499/mo) and Tier 2 ($999/mo) membership fees per subscriber
export const TierWaiverSwitches = ({ client, token }) => {
  const [w, setW] = useState({ 1: !!client.tier1_waived, 2: !!client.tier2_waived });
  const [busy, setBusy] = useState(0);
  const owner = !!client.is_super_admin;
  const toggle = async (tier, waived) => {
    setBusy(tier);
    try {
      const r = await axios.put(`${API}/clients/${client.client_id}/tier-waiver`, { tier, waived }, { headers: { Authorization: `Bearer ${token}` } });
      setW(prev => ({ ...prev, [tier]: waived, ...(tier === 2 && waived ? { 1: true } : {}), ...(tier === 1 && !waived ? { 2: false } : {}) }));
      toast.success(`${client.email}: ${r.data.message}`);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not update the tier waiver'); }
    setBusy(0);
  };
  return (
    <div className="space-y-1" data-testid={`admin-tier-waivers-${client.client_id}`}>
      {[1, 2].map(t => (
        <div key={t} className="flex items-center gap-2">
          <Switch checked={w[t] || owner} disabled={!!busy || owner} onCheckedChange={(v) => toggle(t, v)} className="data-[state=unchecked]:bg-slate-600"
            data-testid={`admin-tier${t}-waiver-switch-${client.client_id}`} />
          <span className={`text-xs whitespace-nowrap ${w[t] || owner ? 'text-emerald-400' : 'text-slate-300'}`} data-testid={`admin-tier${t}-waiver-label-${client.client_id}`}>
            Tier {t} {owner ? 'free (owner)' : w[t] ? 'fee waived' : t === 1 ? '$499/mo' : '$999/mo'}
          </span>
        </div>
      ))}
    </div>
  );
};
